import {SidebarSuggestedWorkflows as Component} from '@github-ui/code-view-sidebar/components/SidebarSuggestedWorkflows'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarSuggestedWorkflows({ownerLogin, repoName}: Props) {
  const {suggestedWorkflows} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!suggestedWorkflows) return null
  return <Component {...suggestedWorkflows} />
}
